import React from 'react';

// 根据实际 shaixuan.svg 内容填充 path（示例为占位符，需替换为真实 SVG 路径）
const RefreshIcon = ({name, color}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={name} width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M21 4V12" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 12V20" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 12C21 7.02945 16.9706 3 12 3C9.45725 3 7.1608 4.05448 5.52405 5.75M3 12C3 16.9706 7.02945 21 12 21C14.4278 21 16.6311 20.0387 18.25 18.476" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default RefreshIcon;
